import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    { paint: 'shadow', d: 'M-3,0h1v0.5h-1zM2,0h1v0.5h-1zM-2.5,0.5h2v0.5h-2zM0,0.5h2.5v0.5h-2.5z' },
    {
      paint: 'mushroom',
      d: 'M0,-9h1v0.5h-1zM-3,-8.5h0.5v0.5h-0.5zM-3,-8h1v0.5h-1zM2,-7.5h1v1h-1zM-1,-6.5h1v0.5h-1zM-2.5,-5h0.5v0.5h-0.5zM-1.5,-5h0.5v0.5h-0.5zM0.5,-5h1.5v0.5h-1.5zM-1.5,-4h2v0.5h-2zM1,-4h0.5v0.5h-0.5zM-2,-3.5h3.5v0.5h-3.5zM-1.5,-3h2v0.5h-2zM1,-3h0.5v0.5h-0.5zM-1.5,-2.5h1.5v0.5h-1.5zM-1.5,-2h2v1.5h-2zM-2,-0.5h2.5v1h-2.5zM-0.5,0.5h0.5v0.5h-0.5z',
    },
    {
      paint: 'wallShade',
      d: 'M4,-6h1v0.5h-1zM-5,-5.5h1v0.5h-1zM1.5,-5.5h3.5v0.5h-3.5zM-4.5,-5h2v0.5h-2zM-2,-5h0.5v0.5h-0.5zM-1,-5h1.5v0.5h-1.5zM2,-5h2.5v0.5h-2.5zM-3.5,-4.5h7v0.5h-7zM0.5,-4h0.5v0.5h-0.5zM0.5,-3h0.5v0.5h-0.5zM0,-2.5h1.5v0.5h-1.5zM0.5,-2h1v0.5h-1zM0.5,-1.5h1.5v1h-1.5zM0.5,-0.5h2v0.5h-2zM0.5,0h1.5v0.5h-1.5z',
    },
    {
      paint: 'mushroomCap',
      d: 'M-0.5,-10.5h1v0.5h-1zM-2.5,-10h4.5v0.5h-4.5zM-3.5,-9.5h1v0.5h-1zM1.5,-9.5h1.5v0.5h-1.5zM-4,-9h1v0.5h-1zM-1,-9h1v0.5h-1zM1.5,-9h2v0.5h-2zM-4.5,-8.5h1v0.5h-1zM-2,-8.5h2v0.5h-2zM1,-8.5h3v0.5h-3zM-5,-8h1v0.5h-1zM-2,-8h6.5v0.5h-6.5zM-5,-7.5h0.5v0.5h-0.5zM-4,-7.5h1v0.5h-1zM-2.5,-7.5h4.5v0.5h-4.5zM3,-7.5h2v0.5h-2zM-5,-7h6.5v0.5h-6.5zM3.5,-7h1.5v0.5h-1.5zM-5.5,-6.5h4v0.5h-4zM0,-6.5h2v0.5h-2zM2.5,-6.5h3v0.5h-3zM-5.5,-6h4.5v0.5h-4.5zM-0.5,-6h4.5v0.5h-4.5zM-3.5,-5.5h3v0.5h-3z',
    },
    {
      paint: 'coral',
      d: 'M-2.5,-9.5h4v0.5h-4zM-3,-9h2v0.5h-2zM1,-9h0.5v0.5h-0.5zM-3.5,-8.5h0.5v0.5h-0.5zM-2.5,-8.5h0.5v0.5h-0.5zM0,-8.5h1v0.5h-1zM-4,-8h1v0.5h-1zM-4.5,-7.5h0.5v0.5h-0.5zM-3,-7.5h0.5v0.5h-0.5zM1.5,-7h0.5v0.5h-0.5zM3,-7h0.5v0.5h-0.5zM-1.5,-6.5h0.5v0.5h-0.5zM2,-6.5h0.5v0.5h-0.5zM-1,-6h0.5v0.5h-0.5zM-4,-5.5h0.5v0.5h-0.5zM-0.5,-5.5h2v0.5h-2z',
    },
  ],
  pixels: 286,
};
export const sprites: readonly PixelSprite[] = [variant0];
